export default () => {
 
    const observerdElements = document.querySelectorAll('.sectionObserved');

    if (!observerdElements.length) {
        return;
    }

    const navElements = document.querySelectorAll('.singleMembers-sidebar--desktop .sidebar-card-list__item');
    const navElementById = (id) => {
        const item = [...navElements].find((element) => {
            return element.querySelector('a').getAttribute('href').replace('#', '') === id;
        })

        if (!item) {
            return false;
        }

        return item.closest('.sidebar-card-list__item')
    };

    const observerCallback = (entries) => {
        entries.forEach((entry) => {
            const id = entry.target.id;
            if(!entry.isIntersecting) {
                entry.target.classList.remove('is-visible');
                return;
            }

            const navElementToActive = navElementById(id);

            if (!navElementToActive) {
                return;
            }
            
            
            navElements.forEach((element) => element.classList.remove('active'));
            navElementToActive.classList.add('active');
        });
    }

    const observer = new IntersectionObserver(observerCallback, {
        rootMargin: '0px 0px -90% 0px',
    });

    observerdElements.forEach((element) => observer.observe(element));
}
